// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1561":"css/app.6937","6021":"css/admin-app.6937"}[chunkId] + ".css";
};